/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

// Self-hosted fonts live in public/ and are linked here rather than imported,
// so the bundler keeps them as separate cacheable files instead of inlining
// them as base64 into the stylesheet.
const fonts = document.createElement("link");
fonts.rel = "stylesheet";
fonts.href = "/fonts/fonts.css";
document.head.append(fonts);

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
